import { Link } from 'react-router-dom';
import { ExternalLink, FileText } from 'lucide-react';

/**
 * Credit Memo tab — preview shell.
 *
 * The full memo authoring/PDF flow lives at /business/cases/:id/memo.
 * This tab summarizes what the memo will contain and links over. When the
 * memo backend lands (Phase 2 — AI summary, PDF export), this tab will
 * inline an editor + preview pane.
 */

export function MemoTab({ caseId }: { caseId: string }) {
  return (
    <div className="space-y-4">
      <div className="card">
        <div className="flex items-start gap-4">
          <div className="w-12 h-12 rounded-lg bg-business-accent/10 flex items-center justify-center flex-shrink-0">
            <FileText className="w-6 h-6 text-business-accent" />
          </div>
          <div className="flex-1">
            <h2 className="text-xl font-semibold text-navy mb-1">
              תיק פנימי — מסמך מו״מ
            </h2>
            <p className="text-sm text-slate-600 mb-4">
              מסמך פנימי ליועץ בלבד — לא להצגה ללקוח הקצה. נבנה אוטומטית מתוך
              ה-snapshot האחרון, ומשמש בסיס למו״מ מול הבנקים.
            </p>

            <Link
              to={`/business/cases/${caseId}/memo`}
              className="btn-primary inline-flex items-center gap-2"
            >
              פתח את המסמך המלא
              <ExternalLink className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </div>

      <div className="card bg-amber-50 border-amber-200">
        <h3 className="font-semibold text-amber-900 mb-2">מה ייכלל במסמך</h3>
        <ul className="text-sm text-amber-900 space-y-1.5 list-disc mr-5">
          <li>Executive Summary — סיכום ניתוחי שמייצר סוכן AI</li>
          <li>טבלת נתונים היסטוריים פר חברה</li>
          <li>EBITDA, תזרים פנוי, שנות החזר נורמטיביות</li>
          <li>ניתוח DSCR דינמי + גרף</li>
          <li>רשימת אתגרים וסיכונים</li>
          <li>המלצות למו״מ מול הבנקים</li>
          <li>הורדת PDF</li>
        </ul>
      </div>
    </div>
  );
}
